var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtitleSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13655_149913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 8C27.552 8 28 8.448 28 9V25C28 25.552 27.552 26 27 26H9C8.448 26 8 25.552 8 25V9C8 8.448 8.448 8 9 8H27ZM15 13C12.792 13 11 14.792 11 17C11 19.208 12.792 21 15 21C16.1 21 17.1 20.55 17.828 19.828L16.414 18.414C16.053 18.776 15.553 19 15 19C13.895 19 13 18.105 13 17C13 15.895 13.895 15 15 15C15.55 15 16.048 15.22 16.415 15.587L17.829 14.173C17.105 13.448 16.105 13 15 13ZM22 13C19.792 13 18 14.792 18 17C18 19.208 19.792 21 22 21C23.104 21 24.104 20.552 24.828 19.828L23.414 18.414C23.052 18.776 22.552 19 22 19C20.895 19 20 18.105 20 17C20 15.895 20.895 15 22 15C22.553 15 23.053 15.224 23.415 15.587L24.829 14.173C24.105 13.448 23.105 13 22 13Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13655_149913",
    x: 0,
    y: 0,
    width: 36,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13655_149913"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13655_149913",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtitleSelected);
export default __webpack_public_path__ + "static/media/subtitle-selected.250d63472fa156e7edf1cbd0bc158d28.svg";
export { ForwardRef as ReactComponent };